<div class="bmc-job-schedules">
  <p>{{'JOBS.SCHEDULES_DESCRIPTION' | translate}}</p>
  <div class="bmc-job-schedules__table">
    <table class="bz-table">
      <thead>
      <tr>
        <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
          <div class="bz-table__col-title" *ngIf="col.visible">
            <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
          </div>

        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let schedule of currentJob.schedules">
        <td class="bz-table__cell" *ngFor="let col of columns">
          <div *ngIf="col.visible">
            <div *ngIf="col.type === 'link' "><a (click)="col.action(schedule)">{{ schedule[col.key] }}</a></div>
            <div *ngIf="col.type === 'text' ">{{ schedule[col.key] }}</div>
            <div *ngIf="col.type === 'type' ">{{ 'JOBS.SCHEDULE_TYPE_' + (schedule[col.key] | uppercase) | translate }}</div>
            <div *ngIf="col.type === 'frequency' ">{{ schedule.frequency[col.key] }}</div>
            <div *ngIf="col.type === 'frequencyType' ">{{ 'JOBS.SCHEDULE_TYPE_' + (schedule.frequency[col.key] | uppercase) | translate }}</div>
            <div *ngIf="col.type === 'date' ">{{ schedule[col.key] | date:'MM/dd/yyyy h:mm a'}}</div>
            <div *ngIf="col.type === 'boolean'">
              <bzg-checkbox [checked]="schedule[col.key]" [disabled]="col.readonly"></bzg-checkbox>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</div>
